import React from 'react'
interface IProps {
  height?: number
}
const Spacer: React.FC<IProps> = props => (
  <div style={{ height: props.height ? props.height : 10 }} />
)
export default Spacer
